import {
  DemandeAffiliationDocument,
  DemandeHabilitationDocument,
  DemandeValidationPjDocument,
} from '@graphql/generated';
import { DocumentFileModel, DocumentModel } from '@lib/ged/document.model';
import { DocumentStatutMapper } from './document-statut-mapper';
import { DocumentTypeMapper } from './document-type-mapper';
import { FileDispositionMapper } from './file-disposition-mapper';
import { NonConformiteMapper } from './non-conformite-mapper';
import { DocumentHistoriqueMapper } from './document-historique-mapper';
import { RetourNcsMapper } from './retour-nc-mapper';
export class DocumentMapper {
  public static fromGraphQl(
    input:
      | DemandeAffiliationDocument
      | DemandeValidationPjDocument
      | DemandeHabilitationDocument,
    isBackOffice: boolean
  ): DocumentModel | undefined {
    if (!input) return undefined;

    return {
      id: input.document!.id,
      statut: DocumentStatutMapper.fromGraphQl(
        isBackOffice ? input.document?.statutBackOffice : input.document?.statutConsultant
      ),
      declarationId: input.document!.id,
      dateUpdate: input.document?.dateUpdate,
      commentaire: input.document?.commentaire,
      documentType: input?.documentTypeId
        ? DocumentTypeMapper.fromGraphQl(input.documentTypeId)
        : 'rib', // todo a supprimer
      fileType: input.document?.fileType,
      dateExpiration: input.document?.dateExpiration,
      files: input.document?.files
        ? input.document.files.map(
            f =>
              ({
                id: f.id,
                filename: f.fileName,
                gedId: f.gedId,
                disposition: FileDispositionMapper.fromGraphQl(f.dispositionId),
              }) as DocumentFileModel
          )
        : [],
      nonConformites:
        input.document?.nonConformites?.map(nc =>
          NonConformiteMapper.fromGraphQl(nc, isBackOffice)
        ) ?? [],
      conformiteHistorique:
        input.document?.historique?.map(h => DocumentHistoriqueMapper.fromGraphQl(h)) ??
        [],
      retourNcs: RetourNcsMapper.fromGraphQl(
        input.document?.retourNcs ?? undefined,
        input.document!.id,
        isBackOffice
      ),
    } as DocumentModel;
  }
}
